export class PopupErrorObject {
	constructor(public responseJson: any, public config?: string, public sourceApplication: string = '') { }
}
